import { Component, OnInit } from '@angular/core';
import{CommonService} from '../../services/common.service';
import { organizationDTO } from 'src/app/models/providersDTO';
import { PersistenceService, StorageType } from 'angular-persistence';
import { NgxSpinnerService } from 'ngx-spinner';
import { ResultsService } from 'src/app/services/results.service';
@Component({
  selector: 'app-ui-footer',
  templateUrl: './ui-footer.component.html',
  styleUrls: ['./ui-footer.component.css']
})

export class UiFooterComponent implements OnInit {
  interval:any;
  public orgDetails: organizationDTO = new organizationDTO();
  contentPath=localStorage.getItem('ContentPath');
  NonDiscriminationNotice=localStorage.getItem('NonDiscriminationNotice');
  Productiondate:any;

  constructor(private commonService:CommonService,private persistenceService: PersistenceService,private spinner: NgxSpinnerService, private resultsService: ResultsService,) { 
    this.orgDetails= persistenceService.get('currentorgDetails', StorageType.SESSION);
    if(this.orgDetails==null || this.orgDetails == undefined || this.orgDetails.logoSrc == undefined ) 
    {
     this.commonService.getOrganizationDetails().then((formdata) => {
       this.persistenceService.set('currentorgDetails',formdata[0], { type: StorageType.SESSION });
       this.orgDetails= formdata[0];
     });
      
    }
  }

  ngOnInit() {
    this.resultsService.getProductionDate().then((data: any[]) => {    
      this.Productiondate = new Date(data[0].ProductionDate);
    });
    this.refreshData();
    this.interval = setInterval(() => { 
        this.refreshData(); 
    }, 20000);
  }

  async refreshData()
  {  
     this.commonService.getOrganizationDetails().then((formdata: organizationDTO) => {
       this.orgDetails= formdata[0];
     });
    this.contentPath=localStorage.getItem('ContentPath');
  }

}
